import { render, staticRenderFns } from "./bem-vindo.vue?vue&type=template&id=31a0b6a0&"
import script from "./bem-vindo.vue?vue&type=script&lang=js&"
export * from "./bem-vindo.vue?vue&type=script&lang=js&"
import style0 from "./bem-vindo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports